module.exports = __webpack_public_path__ + "static/media/moon.4897851c.svg";